import {useEffect, useState} from 'react'

import {Button, Badge, Form} from 'react-bootstrap'

import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'

import {useLazyQuery, useQuery} from '@apollo/client'
import {Spinner} from '../../components/Spinner'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {GET_ALL_VENTAS, GET_CLIENTS_FILTER_VENTAS} from '../../graphql/queries/getVentas'
import type {IResClientsVentas, ResDataVentas, SaleListEdge} from '../../graphql/types/ventasType'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import Flatpickr from 'react-flatpickr'
import {Spanish} from 'flatpickr/dist/l10n/es'

import {hasPermission, parseId, parsePrice} from '../../helpers'
import {useNetworkStatus} from '../../hooks/useNetworkStatus'
import {useGetUser} from '../../hooks/useGetUser'
import {ALL_PERMISSIONS, STATUS_VENTA} from '../../helpers/consts'

export const VentasPage = () => {
  const [gqlGetAllClients, {data, loading, error}] = useLazyQuery<ResDataVentas>(GET_ALL_VENTAS, {
    fetchPolicy: 'no-cache',
  })
  const {
    data: dataClient,
    loading: loadingClient,
    // error: errorClient,
  } = useQuery<IResClientsVentas>(GET_CLIENTS_FILTER_VENTAS)

  const isOnline = useNetworkStatus()
  const {user} = useGetUser()

  const [searchTerm, setSearchTerm] = useState('')
  const [after, setAfter] = useState<string | null>(null)
  const [isPagination, setIsPagination] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [dataArr, setDataArr] = useState<SaleListEdge[]>([])
  const [datesValue, setDatesValue] = useState<{
    createdGte: undefined | string
    createdLte: undefined | string
  }>({
    createdGte: undefined,
    createdLte: undefined,
  })

  const [valueSelect, setValueSelect] = useState('')

  useEffect(() => {
    const variables: {[key: string]: string | number | Date | null} = {
      after,
    }
    if (searchTerm) {
      variables.clientId = parseId(searchTerm)
    }
    if (datesValue.createdGte && datesValue.createdLte) {
      variables.created_Gte = new Date(datesValue.createdGte).toISOString().replace('T05', 'T00')
      variables.created_Lte = new Date(datesValue.createdLte)
        .toISOString()
        .replace('T05:00:00', 'T23:59:59')
    }
    gqlGetAllClients({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [after, searchTerm, datesValue])

  useEffect(() => {
    if (error) {
      toast.error('Error: ' + error.message)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    setIsSearch(false)
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.saleList.edges])
      return
    }
    setDataArr(data.saleList.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!isOnline) return
    if (valueSelect === '') {
      setAfter(null)
      setSearchTerm('')
      return
    }
    setSearchTerm(valueSelect)
    setIsSearch(true)
  }, [valueSelect, isOnline])

  const searchForDates = (e: Date[]) => {
    if (e.length === 1) return

    if (e && e.length === 2) {
      setIsSearch(true)
      const createdGte = new Date(e[0]).toISOString()
      const createdLte = new Date(e[1]).toISOString()

      return setDatesValue({
        createdGte,
        createdLte,
      })
    }
    setDatesValue({
      createdGte: undefined,
      createdLte: undefined,
    })
    setAfter(null)
  }

  if (loading && !isPagination && !isSearch) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de ventas
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  const canterasList = dataArr

  const permissions = user?.tokenAuth.permissions ?? ['']

  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de ventas'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_VENTA) ? (
              <Link className='d-flex align-items-center gap-1 btn btn-primary' to='/agregar-venta'>
                <i className='fa fa-plus' /> Agregar venta
              </Link>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6 align-items-center'>
          <div className='card-title'>
            {/* begin::Search */}
            <div className='d-flex align-items-center position-relative my-1'>
              <Form.Select
                disabled={loadingClient || !isOnline}
                value={valueSelect}
                onChange={(e) => setValueSelect(e.target.value)}
              >
                <option value=''>Seleccione un cliente</option>
                {dataClient?.clientList.edges.map(({node: nodeClient}) => (
                  <option key={nodeClient.id} value={nodeClient.id}>
                    {nodeClient.name}
                  </option>
                ))}
              </Form.Select>
            </div>
            {loading && isSearch && <Spinner size='20px' />}

            {/* end::Search */}
          </div>
          <div
            style={{
              flex: 1,
              maxWidth: '331px',
            }}
          >
            <div className='input-group'>
              <span className='input-group-text' id='basic-addon1'>
                <i className='bi bi-calendar3' />
              </span>
              <Flatpickr
                disabled={!isOnline}
                placeholder='Seleccione fecha(s)'
                className='form-control'
                onChange={(e) => searchForDates(e)}
                options={{
                  mode: 'range',
                  dateFormat: 'd F y',
                  showMonths: 2,
                  locale: Spanish,
                  position: 'auto center',
                }}
              />
            </div>
          </div>
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {canterasList.length > 0 ? (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead className='fw-bold'>
                  <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                    <th>#</th>
                    <th>ID</th>
                    <th>Cliente</th>
                    <th>Valor total</th>
                    <th>Tipo de venta</th>
                    <th>Estado</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-700'>
                  {canterasList.map(({node}, idx) => (
                    <tr key={node.id}>
                      <td className='text-muted'>{idx + 1}</td>
                      <td>{node.invoiceId}</td>
                      <td>{node.client.name}</td>
                      <td>{parsePrice(node.saleTotal)}</td>
                      <td>{node.saleType}</td>
                      <td>
                        <Badge
                          bg={
                            node.status === STATUS_VENTA.ABIERTA
                              ? 'info'
                              : node.status === STATUS_VENTA.CERRADA
                              ? 'danger'
                              : node.status === STATUS_VENTA.ANULADA
                              ? 'dark'
                              : 'light'
                          }
                          className='text-light'
                        >
                          {node.status}
                        </Badge>
                      </td>
                      {/* <td className='text-center'>{node.products.edges.length}</td> */}
                      {/* <td style={{maxWidth: '130px'}} className='truncate-jeiset'>
                        {node.observations}
                      </td> */}
                      <td>
                        <Link
                          className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                          title='Ver'
                          to={`/venta/${parseId(node.id)}`}
                        >
                          <i className='fa fa-eye text-primary' />
                        </Link>
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                className='d-flex text-center w-100 align-items-center justify-content-center'
                style={{height: '30vh'}}
              >
                <div>No hay ventas registrados</div>
              </div>
            )}
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          {data?.saleList.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setAfter(data.saleList.pageInfo.endCursor)
                }}
              >
                Cargar más ventas
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>
    </div>
  )
}
